import { Box } from "@mui/material";

function DummyText() {
  return (
    <Box>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nunc
        tellus, interdum vel lacus sed, commodo accumsan lorem. Morbi pulvinar
        felis dolor, eget rutrum dolor commodo nec. Aenean euismod, mauris eu
        bibendum suscipit, elit risus tincidunt nisi, quis hendrerit ex arcu non
        nunc. Sed at nulla vel lectus facilisis sodales a in tortor. Fusce porta
        imperdiet risus sed auctor. Ut lacinia pretium mauris eget molestie.
        Nunc ac libero nisl. Nam consectetur pellentesque nulla, in viverra leo
        ultrices a. Donec venenatis, elit non tincidunt posuere, erat ligula
        tincidunt neque, vestibulum egestas massa lacus et mi. Aenean non
        fermentum nulla. Mauris pellentesque, turpis id varius aliquet, ipsum
        nisl sollicitudin ex, vitae aliquet est quam tristique quam. Vestibulum
        placerat ligula id sem laoreet, at volutpat leo cursus.
      </p>
      <p>
        Integer luctus, ante vitae mollis lobortis, massa quam tincidunt erat,
        ac facilisis sapien dolor lacinia lectus. Mauris dignissim, sem vel
        ornare consequat, lorem risus elementum neque, ac euismod sapien leo sit
        amet justo. Proin ac purus sollicitudin, suscipit erat sit amet,
        sollicitudin ligula. Duis elementum, est ac posuere tempus, odio nisi
        faucibus dui, in aliquet mauris lorem eu augue. Curabitur placerat
        libero quam, vitae congue ipsum maximus consequat. Nunc ligula est,
        aliquet vel consectetur id, finibus id velit. Mauris convallis nibh
        porta tincidunt suscipit. Lorem ipsum dolor sit amet, consectetur
        adipiscing elit. Vivamus bibendum nunc eu lorem tempus porta. Donec nec
        libero massa. Nam eget convallis dolor, non laoreet odio.
      </p>
      <p>
        Donec pulvinar malesuada enim in consequat. Donec venenatis iaculis
        feugiat. Sed tempor laoreet maximus. Proin nec lacus sed lectus cursus
        ultrices. Sed varius odio sed nunc ornare tristique. Donec nibh massa,
        hendrerit vel leo rhoncus, pharetra condimentum metus. Nullam quis
        dignissim lorem. Donec luctus fermentum dapibus. Etiam at nunc vitae
        nunc efficitur aliquam sit amet eget lacus. Sed quis sodales mi. Ut sed
        velit magna.
      </p>
      <p>
        Mauris fringilla malesuada est, vitae dapibus massa egestas vel. Fusce
        quis sapien accumsan, tempor ex pretium, venenatis ipsum. Fusce
        condimentum accumsan justo dictum hendrerit. Nullam odio justo, ornare
        non nisl eget, aliquam viverra est. Pellentesque finibus, velit eu
        fringilla auctor, mi mauris lacinia elit, et mattis sapien ante quis
        tellus. Nunc aliquam, felis id lobortis luctus, purus urna tempus est,
        ut venenatis sem lacus in nunc. Suspendisse potenti. Curabitur tempus
        sapien id facilisis interdum. Phasellus non lorem erat. Aenean
        sollicitudin at massa at venenatis. Nunc vel lacinia velit, nec euismod
        turpis. Sed efficitur, dui eu hendrerit volutpat, est sem blandit sem,
        in feugiat leo nulla id eros. Praesent efficitur, lorem condimentum
        ultricies porttitor, ligula ex blandit nibh, sit amet ultricies nibh
        nibh sed elit. Nulla efficitur egestas tellus, ut placerat libero
        laoreet at. Sed fringilla eros eget neque rutrum, in pharetra turpis
        tincidunt.
      </p>
      <p>
        Ut magna eros, fringilla nec lacus nec, elementum rhoncus sem.
        Vestibulum tempor lobortis libero a aliquam. Phasellus et lacus nulla.
        Duis mollis magna vitae iaculis auctor. Vivamus ac lacus nec eros
        vulputate pellentesque. Duis pretium lectus et cursus sagittis. Donec
        eleifend massa ac lorem ullamcorper, et feugiat dui semper. Quisque ut
        est accumsan, sollicitudin nulla ut, maximus augue. Integer volutpat
        felis sed metus gravida, non mattis lorem porttitor. Vestibulum leo leo,
        aliquam eu pellentesque a, scelerisque sed libero.
      </p>
    </Box>
  );
}

export default DummyText;
